import gql from 'graphql-tag';
import publicationFragment from './publication';

export default gql`
  fragment suggestionCandidateInAdder on SuggestionCandidate {
    source {
      type
      libraryComment
      ... on KeywordSuggestionSource {
        keyword
      }
      ... on SearchSuggestionSource {
        query
      }
      ... on HighDemandSuggestionSource {
        bookings
        maxSimultaneous
      }
      ... on StaffPicksSuggestionSource {
        author
        body
        createdAt
      }
      ... on MissingPopularSuggestionSource {
        loans
        libraries
      }
      ... on AwardsSuggestionSource {
        awards
      }
      ... on CollaborativeFilteringSuggestionSource {
        position
        among
      }
    }
    publication {
      ...fullPublication
    }
  }

  ${publicationFragment}
`;
